import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      ns="terms"
      sectionKeys={["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9"]}
    />
  );
}
